export default {
  EXIBIR_COMO_BAIXAR: false,
  EXIBIR_COMO_ENVIAR: false,
  EXIBIR_CADASTRO_ONLINE: true,
  EXIBIR_ACESSAR_ONLINE: true,
  EXIBIR_CONSULTA: {
    LEGISLACAO: false,
    AUTENTICIDADE: true,
    MAPA: false,
    PROCESSO: true,
    FALE_CONOSCO: false,
    SEJA_UM_CREDENCIDADO: false,
    ACERVO_FUNDIARIO: false,
    PORTARIA_HOMOLOGACAO: false,
    HEADER: true
  },
  VIDEOS_TUTORIAIS: null,

  EXIBIR_OBSERVACAO_CONSULTA_PROCESSOS: false,
  MAIN: {
    TITULO: 'SICARF-BA - Tecnologia para regularização fundiária das terras do Estado da Bahia',
    EXIBIR_IMPORTANTE: false,
    BACK_GROUND: "background-image: url('static/sicarfPrincipal.png')"
  },
  MANUAL_USUARIO: {
    DESCRICAO: 'Utilize estes manuais como um guia de utilização do SiCARF Off-line e Online, eles contêm as informações sobre como realizar os cadastros e importá-los para o Módulo de Análise, para ser possível iniciar o processo de regularização de sua terra.',
    MANUAL_ON: false,
    MANUAL_OFF: false,
    EXIBIR: false
  },
  HOME_PAGE: {
    ENTRE_EM_CONTATO: {
      SOBRE: 'A Superintendência de Desenvolvimento Agrário - SDA é um órgão público estadual que tem por objetivos promover a regularização fundiária, entendida como instrumento primeiro para ordenar o espaço e democratizar o acesso à terra.',
      ENDERECO: 'Avenida Milton Santos, 986 - Ondina, 40170-110 - Salvador - BA',
      TELEFONE: 'Telefone: (71) 3116-7200',
      SUPORTE: 'Suporte técnico: (71) 3116-7200',
      SITE: 'Site: www.sda.sdr.ba.gov.br',
      HORARIO_FUNCIONAMENTO: 'Segunda à Sexta-feira, de 08:30 às 18:00 horas.',
      EXIBIR_FORMULARIO: true
    },

    CADASTROS_ONLINE: [
      {
        TOLLTIP: 'Para aqueles que querem confirmar se um título de terras foi expedido ou se a área é pública estadual (jurisdição).',
        SPAN: 'Solicitar <b>informação de autenticidade de títulos</b> e de <b>jurisdição de áreas</b>'
      },
      {
        TOLLTIP: 'Para aqueles que pretendem fazer o procedimento de permuta.',
        SPAN: 'Solicitar <b>permuta</b>'
      }
    ],

    CADASTROS_OFFLINE: [
      {
        TOLLTIP: 'Rugularização fundiária para pessoa física que exerce agricultura familiar.',
        SPAN: 'Solicitar a <b>Regularização por Doação</b>',
        TEXTO: '(Alienação Simples Doação)',
        NEED_BREAK: false
      },
      {
        TOLLTIP: 'Rugularização fundiária para pessoa física que exerce agricultura familiar.',
        SPAN: 'Solicitar a <b>Regularização por compra</b>',
        TEXTO: '(Alienação Onerosao)',
        NEED_BREAK: false
      }
    ],

    TITULO_CADASTRO: 'COMO FAZER O SEU CADASTRO',

    TITULO_CADASTRO_OFF: 'CADASTRO',
    SUBTITULO_CADASTRO_OFF: 'OFF-LINE',

    TITULO_CADASTRO_ON: 'CADASTRO',
    SUBTITULO_CADASTRO_ON: 'ON-LINE',

    TEXTO_CADASTRO: '<strong>Cadastro off-line:</strong> para solicitar os serviços no SDA ' +
      'descritos no banner ao lado <strong>Cadastro off-line.</strong> ' +
      'Para realizar os cadastros você deve primeiro instalar no seu computador o sistema.<br/> <br/>' +
      'Atenção! Basta instalar uma vez. <br/><br/>' +
      '<strong>Cadastro on-line:</strong> permite ao usuário solicitar ao SDA ' +
      'os serviços específicos identificados no banner <strong>Cadastro on-line.</strong> ' +
      'Para esses serviços, você não precisa baixar nenhum sistema. ' +
      'Basta clicar em "ACESSE" e ter em mãos os documentos necessários no formato digital.',

    O_SICARF_TITULO: 'O SiCARF',

    O_SICARF: 'É o sistema tecnológico do SDA voltado para cadastrar, ' +
      'informar e regularizar terras do Estado da Bahia de acordo com a legislação. ' +
      'Por meio dele será ampliado o acesso, a eficiência e a trasparência nas solicitações de Regularização Fundiária e ' +
      'demais serviços públicos fundiários usando os benefícios que a ' +
      'tecnologia proporciona a quem precisa ter segurança jurídica. ' +
      'As vantagens do SiCARF são:' +
      '<br>',

    O_SICARF_DESCRICAO: '<b>1.</b> Processo 100% digital, ou seja, sem necessidade do Interessado se deslocar ' +
      'ao SDA para cadastrar, juntar documentos, ou consultar o processo; ' +
      '<br>' +
      '<b>2.</b> Módulo off-line para realizar cadastros mesmo sem acesso ' +
      'momentâneo à internet;' +
      '<br>' +
      '<b>3.</b> Notificação e troca de mensagens com o interessado através ' +
      'de ferramenta on-line;' +
      '<br>' +
      '<b>4.</b> Agilidade no andamento e tramitação dos processos;' +
      '<br>' +
      '<b>5.</b> Desburocratização e maior fluidez do processo de ' +
      'Regularização Fundiária e demais serviços do SDA;' +
      '<br>' +
      '<b>6.</b> Transparência de informações junto ao público externo e ' +
      'outros órgãos;',

    O_SICARF_DESCRICAO_IMG: 'static/sicarfReceptor.png',

    EXIBIR_COMENTARIOS: false,

    EXIBIR_GALERIA: false,

    COMO_FUNCIONA: null
  },

  CENTRAL_DO_INTERESSADO: {
    DESCRICAO: 'é o módulo dentro do SICARF-BA que serve de comunicação entre o SDA e o solicitante do serviço do órgão fundiário estadual. Ele é composto por dois submódulos: a Central de Mensagens e o Cadastro On-line.',
    CADASTROS_ONLINE: {
      DESCRICAO: 'permite ao usuário realizar solicitações para serviços do SDA de informação sobre a expedição de títulos e de permuta.'
    }
  },
  FOOTER: {
    O_SICARF: 'O SiCARF',
    EXIBIR_REDES_SOCIAIS: true,
    ENDERECO: 'Avenida Milton Santos, 986 - Ondina, 40170-110 - Salvador - BA',
    CEP: 'CEP: 40170-110',
    LOGO: 'static/governo-ba.png',
    FACEBOOK: 'https://www.facebook.com/profile.php?id=100011616390372&_rdc=1&_rdr',
    YOUTUBE: 'https://www.youtube.com',
    TWITTER: 'https://twitter.com',
    INSTAGRAM: ' https://www.instagram.com/'
  },

  EXIBIR_OBSERVACOES: false,

  EXIBIR_MODELOS_DOCS: false,

  EXIBIR_DUVIDAS_FREQUENTES: true,

  EXIBIR_CREDENCIADOS: false,

  DOCUMENTOS_NECESSARIOS: {
    OBRIGATORIEDADE_SHAPE: true,

    EXIBIR_DOCUMENTO_QUITACAO: false,

    EXIBIR_CERTIDAO_NASCIMENTO: false,

    EXIBIR_DRL: true
  },

  SIMULAR_VTN: {
    DESCRICAO: '',
    EXIBIR: false
  }

}



// WEBPACK FOOTER //
// ./src/constants/ba/dadosEstado/portal/publico.js